import WebAPI from './api-calls';

const webApi = new WebAPI();

const mapWasteCustomerDetails = (dto) => {
    if (!dto) return null;

    const contract = dto.contract || null;

    return {
        overview: {
            accountNumber: dto.accountNumber,
            companyName: dto.businessName,
            contactName: dto.contactName,
            billingAddress: dto.billingAddress
                ? {
                    address1: dto.billingAddress.addressLine1,
                    address2: dto.billingAddress.addressLine2,
                    address3: dto.billingAddress.addressLine3,
                    townOrCity: dto.billingAddress.addressLine4,
                    county: dto.billingAddress.addressLine5,
                    postcode: dto.billingAddress.postcode,
                }
                : null,
        },
        contact: {
            contactEmail: dto.contactEmailAddress,
            billingEmail: dto.billingEmailAddress,
            contactPhone: dto.contactPhoneNumber,
            mobilePhone: dto.mobileNumber,
            otherMobilePhone: dto.otherMobileNumber,
        },
        accountBalance: contract
            ? {
                accountBalance: contract.terminationDate,
                expectedBilling: contract.expectedBillingDay,
                paymentMethod: contract.paymentMethod,
                billingTerms: contract.billingTerms,
            }
            : null,
        contract,
    };
};

export async function fetchWasteCustomerDetails() {
    const response = await webApi.getFromWebApiWithAccessTokenAsync(
        '/api/multiutility/waste-customer-details'
    );

    if (!response) 
        return null;

    const outer = response.data || {};
    const inner = outer.data || outer;

    const dto =
        inner.customerDetails ||
        inner.customerDetailsDto ||
        inner;

    return mapWasteCustomerDetails(dto);
}